import { NodeExtension, ParamType } from 'helicon';

export const SampleAndHoldExtension: NodeExtension = {
  type: 'SampleAndHold',
  processor: '/SampleAndHoldProcessor.js',
  description: {
    numberOfInputs: 0,
    numberOfOutputs: 1,
    outputChannelCount: [1],
    channelCount: 1,
    channelCountMode: 'explicit',
    channelInterpretation: 'discrete',
    params: {
      clock: {
        type: ParamType.AudioParam,
        default: 0,
      },
      signal: {
        type: ParamType.AudioParam,
        default: 0,
      },
    },
    signals: {
      trigger: {
        trigger: true,
      },
    },
  },
};
